import { memo } from "react";

import { Spacing } from "@snapchat/snap-design-system";
import { areEqual } from "react-window";

import { type RemoteApiSpec } from "../../../../gql-generated/types";
import { LoadableItem } from "../../../../shared/components";
import { type VirtualizedListItemProps } from "../virtualized-list/models";

import { ApiRow } from "./ApiRow";

export const LoadableApiRow = memo<VirtualizedListItemProps<RemoteApiSpec, RemoteApiSpec[]>>(
    ({ index, style, data }) => {
        const { list, onDelete, deleteLoading = false } = data;
        const api = list[index];

        return (
            <LoadableItem style={style} data={api} skeletonHeight={Spacing.MD}>
                {api ? <ApiRow style={style} api={api} onDelete={onDelete} deleteLoading={deleteLoading} /> : <></>}
            </LoadableItem>
        );
    },
    areEqual,
);
